/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createSelector } from '@atlassian/react-sweet-state';
import type { OutputSelector } from '@atlassian/react-sweet-state/src/utils/create-selector.tsx';
import type { NavigationCollection, State } from './NavigationCollection.types.tsx';

export const getCollectionsInitialized = (state: State): boolean => state.collections.initialized;

export const getCollectionsIsLoading = (state: State): boolean => state.collections.isLoading;

export const getCollectionsError = (state: State): Error | null => state.collections.error;

export const getCollectionsData: OutputSelector<State, void, NavigationCollection[]> =
	createSelector(
		(state: State) => state.collections.data,
		(state: State) => state.activeCollectionUUID,
		(collections, activeCollectionUUID) =>
			collections.filter((collection) => collection.uuid === activeCollectionUUID),
	);

export const getCollectionsDataCount = (state: State): number => state.collections.data.length;
